import React, {useCallback, useState, useMemo} from 'react';
import {Link} from 'react-router-dom';
import {Avatar, Menu, ListItemButton, ToggleButton, ListItemIcon} from '@mui/material';
import {styled} from '@mui/material/styles';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';

import {ExpandMoreIcon, ExitToAppIcon} from '../common/icons';

const ArrowIcon = styled(ExpandMoreIcon)(({theme})=>({
    transition: 'transform 0.3s ease-in',
    color: theme.palette.primary.contrastText,
    ['.Mui-selected &']: {
        transform: 'rotate(180deg)',
    },
}));

const AVATAR_COLOR_MAP = {
    [0]: '#83CAFB',
    [1]: '#DEA52C',
    [2]: '#8854D0',
    [3]: '#EF7F88',
    [4]: '#32678F',
    [5]: '#3B4E5C',
    [6]: '#7C5900',
    [7]: '#FF8923',
    [8]: '#F2939C',
    [9]: '#F9CD6F',
};
const getAvatarColor = (name) => (name ? AVATAR_COLOR_MAP[name.length % 10] : '#D6DCE2');
const getInitials = (name='', email)=>{
    // avatar length
    const length = 2;
    // regexp to pick only letters and digits
    const initialsRegex = /[a-zA-Z0-9]/ig;
    // splitting name into words and filtering out empty and non-matching strings
    const chars = name.split(/\s+/).filter((s)=>!!s && initialsRegex.test(s));
    // if there are multiple matching words - picking first 'whitelisted' letters from each
    if (chars.length>1) {
        return chars.map((str)=>str.match(initialsRegex)[0]).slice(0, length).join('');
    }
    // otherwise, trying to pick first 2 allowed letters from first (and only) word
    if (chars.length>0&&chars[0].match(initialsRegex).length>1) {
        return chars[0].match(initialsRegex).slice(0, length).join('');
    }
    // otherwise, picking it from email as a fallback
    return email.match(initialsRegex).slice(0, length);
};


const StyledItemButton = styled(ListItemButton)(()=>({
    'gap': '16px',
    '& .MuiListItemIcon-root': {
        minWidth: '0',
    },
}));

export default function UserMenu({user, handleSignOut}) {
    const initials = useMemo(()=>getInitials(user.name, user.email), [user]);
    const [anchorEl, setAnchorEl] = useState(null);
    const isOpen = Boolean(anchorEl);

    const toggleAnchorEl= useCallback((e)=>{
        setAnchorEl((old)=> old ? null : e.currentTarget);
    }, []);

    return (
      <>
        <ToggleButton value='toggle' variant='text' selected={isOpen} onClick={toggleAnchorEl} sx={{py: 0, display: 'flex', gap: '16px', border: 'none', alignSelf: 'stretch'}}>
          <Avatar sx={{bgcolor: getAvatarColor(user.name)}}>{initials}</Avatar>
          <ArrowIcon />
        </ToggleButton>
        <Menu
          transformOrigin={{horizontal: 'right', vertical: 'top'}}
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          onClose={toggleAnchorEl} anchorEl={anchorEl} open={isOpen}
        >
          <StyledItemButton component={Link} to='/profile'>
            <ListItemIcon><AccountCircleOutlinedIcon /></ListItemIcon>
            Profile
          </StyledItemButton>
          <StyledItemButton onClick={handleSignOut}>
            <ListItemIcon><ExitToAppIcon /></ListItemIcon>
            Sign out
          </StyledItemButton>
        </Menu>
      </>
    );
}
